import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProjectsView from './components/views/ProjectsView';
import WorkspaceView from './components/views/WorkspaceView';
import './styles/vars.css'; // kept for backward compatibility if any component needs it

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ProjectsView />} />
        <Route path="/editor" element={<WorkspaceView />} />
      </Routes>
    </Router>
  );
}